// src/components/Home/CallToAction.js
import React from "react";

export default function CallToAction() {
    return (
        <section className="py-20 bg-gradient-to-r from-red-600 to-red-700 text-white text-center">
            <h2 className="text-4xl font-extrabold mb-6">
                Bắt đầu hành trình tìm bất động sản ngay hôm nay
            </h2>
            <p className="text-lg mb-8">
                Đăng ký tài khoản hoặc liên hệ chúng tôi để được tư vấn miễn phí
            </p>
            <div className="flex justify-center gap-4 flex-wrap">
                <a
                    href="/register"
                    className="px-6 py-3 bg-white text-red-600 font-semibold rounded-lg shadow-md hover:bg-gray-100 transition"
                >
                    Đăng ký ngay
                </a>
                <a
                    href="/contact"
                    className="px-6 py-3 border border-white font-semibold rounded-lg hover:bg-white hover:text-red-600 transition"
                >
                    Liên hệ tư vấn
                </a>
            </div>
        </section>
    );
}
